import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";

import "../styles/Nav.css";

class Nav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDesktop: false,
        };

        this.updatePredicate = this.updatePredicate.bind(this);
    }

    componentDidMount() {
        this.updatePredicate();
        window.addEventListener("resize", this.updatePredicate);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updatePredicate);
    }

    updatePredicate() {
        this.setState({ isDesktop: window.innerWidth > 835 });
    }

    render() {
        const isDesktop = this.state.isDesktop;
        return (
            <div className="navbar-container">
                {isDesktop ? (
                    <div className="navbar d-inline-flex justify-content-between">
                        <NavLink
                            exact
                            to="/"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            home
                        </NavLink>
                        <NavLink
                            to="/bio"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            bio
                        </NavLink>
                        <NavLink
                            to="/tour"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            tour
                        </NavLink>
                        <NavLink
                            to="/press"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            press
                        </NavLink>
                        <NavLink
                            to="/music"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            music
                        </NavLink>
                        <NavLink
                            to="/video"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            video
                        </NavLink>
                        <NavLink
                            to="/gallery"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            gallery
                        </NavLink>
                        <NavLink
                            to="/buy"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            buy
                        </NavLink>
                        <NavLink
                            to="/contact"
                            className="navlink"
                            style={{ textDecoration: "none" }}
                            activeStyle={{
                                textDecoration: "none",
                                color: "white",
                            }}
                        >
                            contact
                        </NavLink>
                    </div>
                ) : (
                    <Menu className="pb-5">
                        <a href="/">home</a>
                        <a href="/bio">bio</a>
                        <a href="/tour">tour</a>
                        <a href="/press">press</a>
                        <a href="/music">music</a>
                        <a href="/video">video</a>
                        <a href="/gallery">gallery</a>
                        <a href="/buy">buy</a>
                        <a href="/contact">contact</a>
                    </Menu>
                )}
            </div>
        );
    }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js